import { render, staticRenderFns } from "./ViewServiceArea.vue?vue&type=template&id=c16c579e&"
import script from "./ViewServiceArea.vue?vue&type=script&lang=js&"
export * from "./ViewServiceArea.vue?vue&type=script&lang=js&"
import style0 from "./ViewServiceArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports